import cn from 'classnames';
import { FC, ReactNode } from 'react';
import { FormattedDate } from 'react-intl';

import styles from './TimelineDayLabel.module.scss';

type TimelineDayLabelProps = {
  date: Date;
  className?: string;
  meta?: ReactNode;
};

export const TimelineDayLabel: FC<TimelineDayLabelProps> = ({
  date,
  className,
  meta,
}) => (
  <div className={cn(styles.container, className)}>
    <span className={cn('h5', styles.day)}>
      <FormattedDate value={date} month="short" day="numeric" />
    </span>
    <span className={cn('p3', styles.year)}>
      <FormattedDate value={date} year="numeric" />
      {meta && <span className={styles.meta}> · {meta}</span>}
    </span>
  </div>
);
